// extracted by mini-css-extract-plugin
module.exports = {"Registration_Check_List":"BusinessRegistration_Registration_Check_List__1Gsk2","Frame_Three":"BusinessRegistration_Frame_Three__t_XDy"};